class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.tryInitialize();
    if (!this.initialized) {
      this.observer = new MutationObserver(() => this.tryInitialize());
      this.observer.observe(this, { childList: true, subtree: true });
    }
  }

  tryInitialize() {
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) return;
    
    this.content = summary.nextElementSibling;
    if (!this.content) return;

    // Remove observer after initialization
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.initialized = true;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    // Use rAF to defer layout read until after current style changes are applied
    requestAnimationFrame(() => {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    });
  }
}

customElements.define('header-menu', HeaderMenu);
